import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'manifest',
    initialState: {manifest: [], manifest_single: false, message: false},
    reducers:{
        getManifest: (state,action)=>{
            state.manifest = action.payload
        },
        getOneManifest: (state,action)=>{
            state.manifest_single = action.payload
        },
        saveManifest: (state,action)=>{
            state.manifest.unshift(action.payload)
            state.message = true
        },
        deleteToManifest: (state,action)=>{
            state.manifest = state.invoices.filter(item=>item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state,action)=>{
            state.message = false
        },
        messageFail: (state,action)=>{
            state.message = 'error'
        }
    }
})

export const getAlLManifest = (str) => apiCall({
    url: 'manifest/',
    method: 'GET',
    onSuccess: slice.actions.getManifest.type
})

export const getAlLThis = (data) => apiCall({
    url: "track/?getall="+data['part']+","+data['code'],
    method: 'GET',
    onSuccess: slice.actions.getManifest.type,
    onFail: slice.actions.messageFail.type,
})

export const manifestSave = (data) => apiCall({
    url: 'manifest/',
    method: 'POST',
    onSuccess: slice.actions.saveManifest.type,
    onFail: slice.actions.messageFail.type,
    headers: {
        "Content-Type": "multipart/form-data",
    },
    data,
})

export const getManifest = (id) => apiCall({
    url: 'manifest/'+id,
    method: 'GET',
    onSuccess: slice.actions.getOneManifest.type,
})

export const deleteManifest = (data) => apiCall({
    url: 'manifest/'+data.id+'/',
    method: 'DELETE',
    onSuccess: slice.actions.deleteToManifest.type,
    onFail: slice.actions.messageFail.type,
})

export default slice.reducer
export const {messageReset} = slice.actions